import type { FaireProductEntity } from "../../entity_types/product";

export const p_65ygkfz8ah: FaireProductEntity = {
  token: "p_65ygkfz8ah",
  type: "product",
  name: "Ukiyo Mt. Fuji Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/55c518a0775e9183b82cf094844ebdd6065b9ca9b1eca660fec5b5c675c3b256.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2ebbe585156f2641c77cb886bf01252f81eb1f446a0e5aecf6067adad11af21.jpeg",
    "https://cdn.faire.com/fastly/5f34e7c328fe01b7df17a265e1289eda379b74f43d416aadc12797619f382833.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Ukiyo Mt. Fuji washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, Origami, O-Gi Fan, Maneki Neko, Japanese Foods, Origami Cranes \nSpecifications\n\n * Type: Washi stickers \n * Design: Ukiyo Mt. Fuji \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:04.395Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
